export default {
  SUBMITTED: 'Submitted',
  PENDING_APPROVAL: 'Pending_Approval',
  SUCCESS: 'Success',
  FAILED: 'Failed',
  PENDING_REMOVAL: 'Pending_Removal',
  DELETED: 'Deleted',
  // New states from member_linked_account table
  LINKED: 'Linked',
};
